/**
 * To learn more about Link Resolving check out the Prismic documentation
 * https://prismic.io/docs/vuejs/beyond-the-api/link-resolving
 */

export default function (doc) {
  if (doc.isBroken) {
    return '/not-found'
  }

  if (doc.type === 'homepage') {
    return '/'
  }
  
  if (doc.type === 'radical_broadcast') {
    return '/'
  }
  
  if (doc.type === 'home') {
    return '/'
  }

  if (doc.type === 'page') {
    return '/' + doc.uid
  }
  
  if (doc.type === 'article') {
    return '/magazine/' + doc.uid
  }
  
  if (doc.type === 'magazine') {
    return '/magazine'
  }
  
  if (doc.type === 'post') {
    return '/news/' + doc.uid
  }

  return '/not-found'
}
